function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { message, Modal } from "@pionex-web-kit/components";
import { EMPTY } from "rxjs";
import { catchError, flatMap, tap } from "rxjs/operators";
import { ExchangeID, ExchangeOrderType } from "TradeAPILib";
import { ParseErrorUtils } from "trade_lib_wrapper";
import { TModal } from "../../../components/TinyComps";
import TradeUtil from "../../../TradeLib/TradeUtils";
import { tradingConfig } from "../../../utils/config";
import { kycV2GuideRoute } from "../../../utils/kycInfo";
import { Mixpanel } from "../../../utils/report";
import { CreateOrderPrepare } from "./TradePrepare";
export var OrderCreator = {
  /**
   * 强制内部处理错误，不再向外抛出
   * @return 是否已经处理了错误
   */
  forceProcessError: function forceProcessError(error, $st) {
    if (!error) {
      return false;
    }
    if (error.code === -99090 || error.code === 40300940) {
      // 未绑定邮箱
      TModal.info({
        title: $st("kyc_create_order_error_title"),
        content: $st("kyc_create_order_error_hint"),
        okText: $st("common_go_bind"),
        onOk: function onOk() {
          tradingConfig.history.push("/account/bind");
        }
      });
      return true;
    }
    if (error.code === -99100 || error.code === 40300930) {
      // 未做kyc
      TModal.info({
        title: $st("account_kyc"),
        content: $st("kyc_create_order_error2"),
        okText: $st("kyc_go_do"),
        onOk: function onOk() {
          tradingConfig.history.push(kycV2GuideRoute, {
            from: "trade"
          });
        }
      });
      return true;
    }
    return tradingConfig.customOrderCreator.forceProcessError(error, $st);
  },
  processCreateOrderError: function processCreateOrderError(orderType, error, base, quote, $st, market) {
    if ((error === null || error === void 0 ? void 0 : error.code) === -45 || (error === null || error === void 0 ? void 0 : error.code) === -46) {
      var url = $st("pionex_url_from_binance_max_2_bot_desc");
      Modal.confirm({
        title: $st("trade_bot_can_not_open_more"),
        content: market === ExchangeID.BINANCE ? $st("trade_bot_can_not_open_more_5_1_binance_desc") : $st("trade_bot_can_not_open_more_reason", {
          market: market
        }),
        okText: $st("button_confirm"),
        cancelText: $st("button_cancel"),
        onOk: function onOk() {
          return window.location.href = url;
        }
      });
      return;
    }
    TradeUtil.tradePoliticFilter(error, orderType, function () {
      var decodeError = ParseErrorUtils.parseCreateOrderError(orderType, error, base, quote, $st);
      message.error(decodeError);
    });
  },
  createOrder: function createOrder(orderRequest, baseDisplay, quote, orderType, api, $st, onSuccess) {
    var _this = this;
    var processResultForUI = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : true;
    var isSwap = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
    return CreateOrderPrepare(orderRequest, orderType, baseDisplay).pipe(flatMap(function (res) {
      if (res) {
        return api.createOrderObservable(orderRequest, null);
      }
      throw {
        code: -100001,
        message: "prepare not success"
      };
    })).pipe(catchError(function (err) {
      if (_this.forceProcessError(err, $st)) {
        // 已处理，不再向外抛出错误
        return EMPTY;
      }
      TradeUtil.reportCreateOrderResult(orderType, false);
      if (!processResultForUI) {
        throw err;
      }
      // -49，维护中，不禁止下单, 网格2.0不进行toast
      if (err.code === -49 || err.code === -50004) {
        var isGridPRO = orderType === ExchangeOrderType.gridClassic || orderType === ExchangeOrderType.gridPro || orderType === ExchangeOrderType.gridLeverage || orderType === ExchangeOrderType.gridLeverageShort || orderType === ExchangeOrderType.gridShort || orderType === ExchangeOrderType.gridLoan;
        if (isGridPRO) {
          throw err;
        }
      }
      if (err && err.code !== -100001) {
        _this.processCreateOrderError(orderType, err, baseDisplay, quote, $st);
      }
      throw err;
    })).pipe(tap(function (result) {
      TradeUtil.reportCreateOrderResult(orderType, true);
      // 上报下单成功信息
      processResultForUI && $st && message.success(isSwap ? $st("swap_success") : $st("trade_create_order_success"));
      onSuccess && onSuccess(result);
      try {
        if (orderType === ExchangeOrderType.market || orderType === ExchangeOrderType.limit || orderType === ExchangeOrderType.SL_Pro) {
          var _result$orderData$sym = result.orderData.symbol.split("/"),
            _result$orderData$sym2 = _slicedToArray(_result$orderData$sym, 2),
            base = _result$orderData$sym2[0],
            _quote = _result$orderData$sym2[1];
          Mixpanel.reportManualTrade(result.orderData.type, result.orderData.side, base, _quote);
        } else {
          if (orderType === ExchangeOrderType.SR && result.orderData && result.orderData.bu_order_data) {
            var baseList = result.orderData.bu_order_data.portfolio.map(function (item) {
              return item.base;
            });
            Mixpanel.reportBotCreateEvent(JSON.stringify(baseList), result.orderData.quote, orderType, orderRequest.copyType === "ai");
          } else {
            var _base2, _quote3;
            var _base;
            var _quote2;
            for (var key in orderRequest) {
              _base = orderRequest[key].base;
              _quote2 = orderRequest[key].quote;
              if (_base && _quote2) {
                break;
              }
            }
            Mixpanel.reportBotCreateEvent((_base2 = _base) !== null && _base2 !== void 0 ? _base2 : "", (_quote3 = _quote2) !== null && _quote3 !== void 0 ? _quote3 : "", orderType, orderRequest.copyType === "ai");
          }
        }
      } catch (e) {
        console.error(e);
      }
    }));
  }
};
/**
 * 外部配置的自定义处理
 */
export var customOrderCreator = {
  forceProcessError: function forceProcessError() {
    return false;
  }
};